import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { utils } from "../../../Helpers/utils";
import { getNotificationIcon } from "../../../Helpers/notificationIcons";

export default function NotificationItem(props) {
  const delButton = useRef(null);
  const viewButton = useRef(null);
  const [tab, setTab] = useState("main");
  const navigate = useNavigate();
  const setRead = () => {
    let newNotifModul = [...props.NotifModul];
    const newVisitedItemIndex = newNotifModul.findIndex((item) => {
      return item.id === props.id;
    });
    props.updateNotificationStatus(
      newNotifModul[newVisitedItemIndex].id,
      "read"
    );
    newNotifModul[newVisitedItemIndex].read = true;
    props.setNotifModul(newNotifModul);
    props.setModalData();
    if (props.modal !== "notifDetail") {
      props.setModalNotification("notifDetailDash");
    } else {
      props.setModalNotification("notifDetail");
    }
    props.setModalNotificationData(newNotifModul[newVisitedItemIndex]);
    //props.setModalNotification("notifDetailDash");
  };
  const clickFunc = (e) => {
    props.setModalData();
    //props.setModalData("notifDetail");
    if (e.target === delButton.current) setTab("delete");
    else if (e.target === viewButton.current) navClickHandler();
    else setRead();
  };

  useEffect(() => {
    if (props.readAll === true) {
      let newNotifModul = [...props.NotifModul];
      newNotifModul.forEach((item) => {
        item.read = true;
      });
      props.setNotifModul(newNotifModul);
    }
    // eslint-disable-next-line
  }, [props.readAll]);
  const navClickHandler = () => {
    console.log(props);
    if (props.buttonText === "View payment") {
      let newNotifModul = [...props.NotifModul];
      const newVisitedItemIndex = newNotifModul.findIndex((item) => {
        return item.id === props.id;
      });
      newNotifModul[newVisitedItemIndex].read = true;
      props.setNotifModul(newNotifModul);
      props.setModal(null);
      navigate("/influencer/payment");
    } else if (props.buttonText === "View details") {
      if (
        props.sytemNotiType === "campaign_activity" ||
        props.sytemNotiType === "campaign_complete" ||
        props.sytemNotiType === "revision_activity"
      ) {
        props.setModal(null);
        navigate("/brand/campaigns?id=" + props.opportunity_id);
      } else if (props.sytemNotiType === "token_expired") {
        props.setModal(null);
        navigate("/influencer/social_accounts");
      } else if (props.sytemNotiType === "revision_activity_inf") {
        props.setModal(null);
        navigate("/influencer/collaborations?id=" + props.opportunity_id);
      } else {
        let newNotifModul = [...props.NotifModul];
        const newVisitedItemIndex = newNotifModul.findIndex((item) => {
          return item.id === props.id;
        });
        newNotifModul[newVisitedItemIndex].read = true;
        props.setNotifModul(newNotifModul);
        let expirayDate = props.expired.split("-");
        if (
          props.expired &&
          new Date(
            expirayDate[1] + "-" + expirayDate[2] + "-" + expirayDate[0]
          ) < new Date()
        ) {
          props.setModalData();
          props.setModal("notifExpired");
          navigate("/influencer/opportunities");
        } else {
          props.setModal(null);
          navigate("/influencer/opportunities");
        }
      }
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      {tab === "main" && (
        <div
          className={
            "notificationItem mod !bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 p-2 lg:col-span-2 xl:col-span-1" +
            (props.read ? "" : "unread ") +
            (props.accountCount > 1 ? "moreAcc " : "")
          }
          onClick={clickFunc}
        >
          {props.accountCount > 1 && (
            <div className="notificationItem__account">
              {props.handle.icon &&
                props.handle.icon[0] !== "" &&
                props.handle.icon[0] !== null &&
                utils.getIconFilled(props.handle.icon[0])}
              {props.handle && <span>{props.handle.handle}</span>}
            </div>
          )}
          <span className="notificationItem__circle"></span>
          <div
            style={{
              width: "clamp(32px, 8vw, 42px)",
              height: "clamp(32px, 8vw, 42px)",
              borderRadius: "50%",
              overflow: "hidden",
              boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              backgroundColor: "#F3F4F6",
              border: "1px solid #F1F5F9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {props.image?.startsWith("http") ? (
              <img
                src={props.image}
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            ) : (
            getNotificationIcon(props.sytemNotiType, window.innerWidth < 640 ? 16 : 20)
            )}
            {/* <img src={process.env.PUBLIC_URL + props.image} alt={props.id} /> */}
          </div>
          <div
            className={
              "notificationItem__content " + (props.buttonText ? "pb" : "")
            }
          >
            <div className="notificationItem__content-title">
              <h6>{props.title}</h6>
              {props.date && <p className="sm"> {formatDate(props.date)}</p>}
            </div>
            {/*<p className="sm">{props.subtitle}</p>*/}
            <p className="sm">{props.text}</p>
            {props.buttonText && (
              <div className="notificationItem__content-btns">
                {props.buttonText === "View payment" && (
                  <button ref={viewButton} className="button primary">
                    {props.buttonText}
                  </button>
                )}
                {props.buttonText === "View details" && (
                  <button ref={viewButton} className="button primary">
                    {props.buttonText}
                  </button>
                )}
                <button className="button secondary" ref={delButton}>
                  Delete
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      {tab === "delete" && (
        <div className="notificationDelete">
          <h4>Delete notification?</h4>
          <p className="sm">
            Please confirm you would like to delete this notification.
          </p>
          <div className="notificationDelete__btns">
            <button
              className="button primary"
              onClick={() => {
                setTab("main");
                props.updateNotificationStatus(props.id, "deleted");
              }}
            >
              Yes, delete
            </button>
            <button className="button secondary" onClick={() => setTab("main")}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
}
